import { Chip, Stack, styled } from '@mui/material';
import { ComponentProps } from 'react';

export const StyledFormulaTagsContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  flex: 1,
  maxWidth: '100%',
  flexWrap: 'wrap',
  justifyContent: 'flex-start',
  gap: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    justifyContent: 'center',
  },
}));

export const StyledFormulaTag = (props: ComponentProps<typeof Chip>) => (
  <Chip variant="outlined" {...props} />
);

export const StyledPreviewTag = styled(StyledFormulaTag)(({ theme }) => ({
  color: theme.palette.warning.main,
  borderColor: theme.palette.warning.main,
}));
